const ACTIONS = {
  PREPARE_APP: 'PREPARE_APP',
  SELECT_ROOM_ID: 'SELECT_ROOM_ID',
  RESET_APP: 'RESET_APP'
};

export default ACTIONS;
